import React from 'react';
import {BrowserRouter as Router,Route} from "react-router-dom";

//Votcall Routes
import SaevolgoVoiceMessages from '../../containers/Saevolgo/VoiceMessages/index';
import ExternalVoiceMessages from '../../containers/Saevolgo/ExternalVoiceMessages/index';
import Index from '../../containers/Saevolgo/Index';
import Messages from '../../containers/Saevolgo/Messages/Index';
import VoicemailSettings from '../../containers/Saevolgo/VoicemailSettings';
import CallParkings from '../../containers/Saevolgo/CallParkings';
import SnapHD from '../../containers/Saevolgo/SnapHd';
import Textable from '../../containers/Saevolgo/Textable';
import QrGenerator from '../../containers/Saevolgo/QrGenerator';
import CallLogs from '../../containers/Saevolgo/CallLogs';
import AppSignin from '../../containers/Saevolgo/Auth/AppSignin';
import AuthCallback from '../../containers/Saevolgo/Auth/AuthCallback';

const routes = (props) => (
  <Router>

    <div>


        <Route path='/voice_messages' render={(props) => <SaevolgoVoiceMessages {...props}/>}/>
        <Route path='/external_voice_messages' render={(props) => <ExternalVoiceMessages {...props}/>}/>
        <Route path='/index' render={(props) => <Index {...props}/>}/>
        {/* <Route path='/message' render={(props) => <Messages {...props}/>}/> */}
        <Route path='/vmail_settings' render={(props) => <VoicemailSettings {...props}/>}/>
        <Route path='/call_parkings' render={(props) => <CallParkings {...props}/>}/>
        <Route path='/call_logs' render={(props) => <CallLogs {...props}/>}/>
        <Route path='/snap_hd' render={(props) => <SnapHD {...props}/>}/>
        <Route path='/textable' render={(props) => <Textable {...props}/>}/>
        <Route path='/getQR' render={(props) => <QrGenerator {...props}/>}/>

        <Route path='/messages' render={(props) => <Messages {...props}/>}/>

        <Route path='/app_signin' render={(props) => <AppSignin {...props}/>}/>
        <Route path='/authCallback' render={(props) => <AuthCallback {...props}/>}/>
    </div>

  </Router>
);

export default routes;
